<h3>Tarefas para renúncia</h3>

<div class="container">
  <div ngbAccordion>

    <div ngbAccordionItem>
      <div ngbAccordionHeader>
        <button class="title" ngbAccordionButton>Criar Janela Solicitação de Renúncia</button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <form [formGroup]="formJanelaRenuncia" class="form">
              <div class="row">
                <div class="bn-form-group col-md-8">
                  <label class="form-label" for="tipoJanela"><b>Selecione o tipo da Renúncia: </b></label>
                  <select (change)="selecionarTipoJanela()" id="tipo" class="form-select" [compareWith]="compararPorId" formControlName="tipoJanela">
                    <option *ngFor="let tipo of tipoJanela" [ngValue]="tipo.value">
                              {{ tipo.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *ngIf="possuiTipoSelecionado()">                
                <div class="bn-form-group col-md-4">
                  <label class="form-label" for="dataInicioVigencia"><b>Data de vigência inicial: </b></label>
                  <bn-datepicker idInput="dataInicioVigencia" [minDate]="dataHoje" formControlName="dataInicioVigencia" ></bn-datepicker>
                </div>
      
                <div class="bn-form-group col-md-4">
                  <label class="form-label" for="dataFimVigencia"><b>Data de vigência final: </b></label>
                  <bn-datepicker idInput="dataFimVigencia" [minDate]="dataHoje" formControlName="dataFimVigencia" ></bn-datepicker>
                </div>
              </div>
              <div class="row" *ngIf="possuiTipoSelecionado()">
                <div class="bn-form-group col-md-2">
                  <button placement="top" type="button" (click)="consultar()" class="btn btn-success no-margin">Consultar</button>
                </div>

                <div class="bn-form-group col-md-2">
                  <button placement="top" type="button" [disabled]="podeCadastrar() || !formJanelaRenuncia.valid" (click)="cadastrar()" class="btn btn-success no-margin">Criar</button>
                </div>

                <div class="bn-form-group col-md-2">
                  <button placement="top" type="button" [disabled]="podeCadastrar()" (click)="limpar()" class="btn btn-secondary no-margin">Limpar</button>
                </div>
              </div> 
            </form>
          </ng-template>
        </div>
      </div>
    </div>

    <div *ngIf="podeApurarRenuncias()" ngbAccordionItem>
      <div class="d-flex justify-content-between" ngbAccordionHeader>
        <button class="title" ngbAccordionButton>Apuração da Renúncia à Cobertura Máxima de Inadimplência</button>
      </div>

      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">

              <div *ngIf="!janelaApurada" class="submit col-auto">
                <button type="button" class="btn btn-success no-margin" (click)="abrirModalConfirmarApuracao(TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA)">Executar apuração da Renúncia à Cobertura Máxima de Inadimplência</button>
              </div>

              <div *ngIf="janelaApurada" class="submit col-auto">
                <button disabled type="button" class="btn btn-success no-margin" (click)="abrirModalConfirmarApuracao(TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA)">Executar apuração da Renúncia à Cobertura Máxima de Inadimplência</button>
              </div>
              <div *ngIf="janelaApurada" class="col-auto">
                <button type="button" class="btn no-margin"><b>Apuração de renúncia executada em {{dataHoraApuracao | date: 'dd/MM/yyyy HH:mm'}}</b></button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div *ngIf="podeApurarRenuncias()" ngbAccordionItem>
      <div class="d-flex justify-content-between" ngbAccordionHeader>
        <button class="title" ngbAccordionButton>Apuração da Renúncia Limite Adicional</button>
      </div>

      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <label class="form-label" for="janelaLimiteAdicionalEncerrada"><b>Selecione a janela para apuração: </b></label>
              
              <div class="bn-form-group col-md-4">
                <select [(ngModel)]="janelaLimiteAdicionalEncerrada" id="janelaLimiteAdicionalEncerrada" class="form-select">
                  <option *ngFor="let janela of janelasLimiteAdicionalEncerradas" [ngValue]="janela">
                            {{ janela.dataInicioVigencia | date:'dd/MM/yyyy' }} - {{ janela.dataFimVigencia | date:'dd/MM/yyyy' }}
                  </option>
                </select>
              </div>

              <div class="submit col-auto">
                <button type="button" class="btn btn-success no-margin" [disabled]="!podeExecutarApuracaoLimiteAdicional()" (click)="abrirModalConfirmarApuracao(TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL)">Executar Apuração da Renúncia</button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</div>
<ng-template #body>
  <span>{{ mensagemModal }}</span>
  <br />
  <br />
  Você confirma?
  <br />
</ng-template>
<ng-template #botoes>
  <button class="btn btn-md btn-success" (click)="apurarRenuncia()">
    Sim
  </button>
  <button class="btn btn-md btn-danger" (click)="dismissModal()">
    Não
  </button>
</ng-template>